import { Outlet, Navigate, useLocation } from 'react-router-dom';

type GrantedRouteProps = {
  allowed: boolean;
  redirect: string;
};

export const GrantedRoute = ({ allowed, redirect }: GrantedRouteProps) => {
  const location = useLocation();

  if (allowed) {
    return <Outlet />;
  }

  return (
    <Navigate
      to={redirect}
      state={{ from: location }}
      replace
    />
  );
};
